function YM_GOAL(id) {
    if (window.yaCounter50291011) {
        window.yaCounter50291011.reachGoal(id);
    }
}

$(function () {
    $('.header__contacts_link--phone').on('click', function () {
        YM_GOAL('CALL_CLICK');
    });
});
